import img0 from '../Components/Images/logo.png';
import img1 from '../Components/Images/Brands/TATA.png'
import img2 from '../Components/Images/Brands/SUZUKI.png';
import img3 from '../Components/Images/Brands/HYUNDAI.png';
import img4 from '../Components/Images/Brands/TOYOTA.png';
import img5 from '../Components/Images/Brands/MG.png';
import img6 from '../Components/Images/Brands/HONDA.png';
import img7 from '../Components/Images/Brands/SKODA.png';
import img8 from '../Components/Images/Brands/NISSAN.png';
import img9 from '../Components/Images/Brands/VOLKSWAGON.png';
import img10 from '../Components/Images/Brands/JEEP.png';
import img11 from '../Components/Images/Brands/CITROEN.png';
import img12 from '../Components/Images/Brands/KIA.png';
import img13 from '../Components/Images/Team/PSimage.png';
import img14 from '../Components/Images/Team/MGimage.png';
import img15 from '../Components/Images/Team/SGimage.png';
import img16 from '../Components/Images/logo2.png';
import img17 from '../Components/Images/StartUpLogo1.png';
import img18 from '../Components/Images/StartUpLogo2.png';
import img19 from '../Components/Images/CustomerSupport.png';
import img20 from '../Components/Images/Get in Touch.jpg';
import img21 from '../Components/Images/TermsCond.jpeg';
import img22 from '../Components/Images/PrivacyPolicy.jpeg';
import img23 from '../Components/Images/bgEffect.png';
import img24 from '../Components/Images/Login.png';
import img25 from '../Components/Images/careers.jpeg';
import img26 from '../Components/Images/logo2.png';

export const images = [
    {
        id:0,
        url:img0
    },
    {
        id:1,
        url:img1
    },
    {
        id:2,
        url:img2
    },
    {
        id:3,
        url:img3
    },
    {
        id:4,
        url:img4
    },
    {
        id:5,
        url:img5
    },
    {
        id:6,
        url:img6
    },
    {
        id:7,
        url:img7
    },
    {
        id:8,
        url:img8
    },
    {
        id:9,
        url:img9
    },
    {
        id:10,
        url:img10
    },
    {
        id:11,
        url:img11
    },
    {
        id:12,
        url:img12
    },
    {
        id:13,
        url:img13
    },
    {
        id:14,
        url : img14
    },
    {
        id:15,
        url: img15
    },
    {
        id:16,
        url:img16
    },
    {
        id:17,
        url : img17
    },
    {
        id: 18,
        url : img18
    },
    {
        id: 19,
        url : img19
    },
    {
        id: 20,
        url : img20
    },
    {
        id : 21,
        url : img21
    },
    {
        id : 22,
        url : img22
    },
    {
        id : 23,
        url : img23
    },
    {
        id: 24,
        url : img24
    },
    {
        id:25,
        url : img25
    },
    {
        id:26,
        url : img26
    }
]